import {
  GenericVehicleDetails,
  parseFilterValues,
  ProductLink,
  useProductListItems,
} from '@finn/ua-vehicle';
import { CTA } from '@finn/ui-components';
import { parseToHtml } from '@finn/ui-utils';
import React, { useMemo } from 'react';

import { type ProductSliderCosmicMetadata } from '../ProductSlider/types';

const ProductSlider: React.FunctionComponent<{
  data: ProductSliderCosmicMetadata;
}> = ({ data: { title, filters, cta, vehicles: ssrVehicles } }) => {
  const newFilters = useMemo(() => parseFilterValues(filters), [filters]);
  const { products } = useProductListItems(
    {
      filters: newFilters,
      limit: 18,
    },
    { fallbackData: { results: ssrVehicles, offset: 0, total_results: 0 } }
  );

  const vehicles: GenericVehicleDetails[] = useMemo(() => {
    const uniqueModels = {};
    products.forEach((vehicle) => {
      const key = `${vehicle.brand.id}  ${vehicle.model}`;
      if (uniqueModels[key] === undefined) {
        uniqueModels[key] = vehicle;
      }
    }, {});

    return Object.values(uniqueModels);
  }, [products, filters.models]);

  return (
    <>
      {title && (
        <div className="container">
          <h2 className="mobile-t2-semibold md:web-t2-semibold mb-10 whitespace-pre-line">
            {parseToHtml(title)}
          </h2>
        </div>
      )}
      <div className="container -my-4">
        <div className="flex w-full flex-wrap gap-4">
          {vehicles.map((vehicle) => (
            <div
              key={vehicle.id}
              className="w-full sm:w-1/3"
              data-testid="vehicle"
            >
              <ProductLink
                vehicle={vehicle}
                urlParams=""
                isForIframe={false}
                target="listing"
                className="body-14-light block"
              >
                {vehicle.brand?.id} {vehicle.model}
              </ProductLink>
            </div>
          ))}
        </div>
      </div>
      {cta && (
        <div className="container">
          <div className="mt-12 sm:mt-14">
            <CTA data={cta.metadata} />
          </div>
        </div>
      )}
    </>
  );
};

export default ProductSlider;
